import { render, staticRenderFns } from "./PriorityMark.vue?vue&type=template&id=61882948&"
import script from "./PriorityMark.vue?vue&type=script&lang=js&"
export * from "./PriorityMark.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports